<!--
 * @Author: chengjia 645680217@qq.com
 * @Date: 2022-10-11 13:43:42
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2024-02-20 11:04:39
 * @FilePath: \xm-runing-main\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <ConfigProvider :locale="locale">

    <Watermark v-if="pageWaterFlagVal" class="h99b w99b" style="position: absolute;pointer-events: none;"  v-bind="model"></Watermark>
    <!-- 独立顶层路由：完全绕过AppProvider和LayoutDefault，无闪烁 -->
    <router-view v-if="isStandaloneRoute" />
    <AppProvider v-else-if="showPageFlag">
      <template v-if="isSinglePage !== 'true'">
        <LayoutDefault :singlePageFlag="singlePageFlag"
                       :class="[curLang, loginUserType,singlePageFlag?'singlePage':'']"
                       v-if="runningShow" id="main_router_view_running"/>
        <AppShowLayout :singlePageFlag="singlePageFlag"
                       :templateId="templateId"
                       :appId="appId"
                       :showType="showType" v-else/>
      </template>
      <template v-else>
        <div id="frame" class="w100b h100b"></div>
      </template>
    </AppProvider>
    <div
      class="w100b h100b loadingApp"
      v-if="loadingFlag"
      style="display: flex; justify-content: center; align-items: center; z-index: 999999"
    >
      <spin class="totalLoading wh100b" tip="Loading..."/>
    </div>
  </ConfigProvider>
  <!-- 多模板打印选择组件 -->
  <MultiTemplateSelectModal />

  <!-- 页签内容区详情抽屉宿主（DOM 挂到 #PageLayout，不盖侧栏/顶栏） -->
  <PageContentDrawer v-if="!isStandaloneRoute" />
  <!-- 变更记录抽屉宿主：ViewModel.openChangeRecord 打开 -->
  <ChangeRecordDrawer v-if="!isStandaloneRoute" />

  <!-- 更新日志弹窗 -->
  <UpdateLogModal v-if="!isStandaloneRoute" ref="updateLogModalRef" />
</template>
<script lang="ts" setup>
import Watermark from "@/components/Watermark/Watermark.vue";
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import {ref, onMounted, watch} from 'vue';
import {useRoute} from 'vue-router';
import {ConfigProvider} from 'ant-design-vue';
import {AppProvider} from '@/components/Application';
import {useLocale} from '@/i18n/useLocale';
import {getUrlParams, GoingNewUtils, StorageUtils} from 'xmgoing-utils';
import LayoutDefault from '@/layouts/default/index.vue';
import AppShowLayout from '@/layouts/layoutFrame/appShowLayout.vue';
import {Spin} from 'ant-design-vue';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import {loadUserInfo} from '@/utils/xmCom/loadSystem';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import {prefetchApps} from 'qiankun';
import {prefetchAppsList} from '@/migo/apps';
import {useAppAndTemplate} from "@/hooks/useAppAndTemplate";
import {useAppLoad} from "@/hooks/useAppLoad";
import emitter from "@/events/eventBus";
import {useLockStore} from "@/store/modules/lock";
import {useAppStore} from "@/store/modules/app";
import {useWatermarkHooks} from '@/components/Watermark/hooks/useWatermarkHooks';
import {useLoginSwitchHook} from "@/hooks/useLoginSwitchHook";
import {useMesProConfigHooks} from "@/hooks/useMesProConfigHooks";
import MultiTemplateSelectModal from '@/components/multiTemplatePrint/MultiTemplateSelectModal.vue';
import PageContentDrawer from '@/components/pageContentDrawer/PageContentDrawer.vue';
import ChangeRecordDrawer from '@/main-page/components/ChangeRecordDrawer.vue';
import UpdateLogModal from '@/components/updateLogModal/UpdateLogModal.vue';
import { isStandalonePath } from '@/router/standaloneRoute';

const appStore = useAppStore();
const lockStore = useLockStore();
lockStore.resetLockInfo();
window.subAppObj={};

const useLockStoreEvent=function () {
  nextTick(() => {
    lockStore.setLockInfo({isLock: true});
  })
}

// 定义定时器集合用于清理
const timers: Set<NodeJS.Timeout> = new Set();

onBeforeUnmount(() => {
  window.appObj.sessionTimeout = false;
  window.subAppObj=window.appObj;
  emitter.off('useLockStore',useLockStoreEvent);
  emitter.off('showUpdateLogModal');
  // 清理所有定时器
  timers.forEach(timer => {
    clearTimeout(timer);
  });
  timers.clear();
});
//证明保活为true
StorageUtils.addSessionItem('keepAlive','true');

window.eventBus = emitter;
onMounted(() => {
  emitter.on('useLockStore',useLockStoreEvent)
  emitter.on('showUpdateLogModal', () => {
    if (!route.path.includes('/updateLog')) {
      updateLogModalRef.value?.checkAndShowUpdateLog(true);
    }
  })
  window.setPageName = function (pagName) {
    const appStore = useAppStore();
    appStore.setPageName(pagName);
  }
})

/**
 * mes产品配置信息
 */
const {mesProConfig}=useMesProConfigHooks();
provide('mesProConfig', mesProConfig);

//单页界面标志
const singlePageFlag = ref(false);
singlePageFlag.value = GoingNewUtils.parseBoolean(getUrlParams("singlePage", true) + "");
const {href} = location;
prefetchApps([...prefetchAppsList]);
const locale = ref(zhCN);
dayjs.extend(quarterOfYear);
dayjs.locale('zh-cn');
// support Multi-language
const {getAntdLocale} = useLocale();
watch(getAntdLocale, (val) => {
  dayjs.locale(val);
});
const loginUserType =
  getUrlParams('loginUserType', true) || StorageUtils.getSessionItem('loginUserType');
const curLang = StorageUtils.getSessionItem('projectI18n') || StorageUtils.getItem('projectI18n');
const showPageFlag = ref(false);
// 独立顶层路由（不包裹在LayoutDefault中）
const route = useRoute();
// 首屏同步判定，避免 router / curHref 重定向前误渲染 LayoutDefault
const isStandaloneRoute = ref(isStandalonePath(window.location.pathname));
watch(
  () => route.path,
  (path) => {
    isStandaloneRoute.value =
      isStandalonePath(path) || isStandalonePath(window.location.pathname);
  },
  { immediate: true },
);
// 更新日志弹窗
const updateLogModalRef = ref<InstanceType<typeof UpdateLogModal> | null>(null);

//加载用户相关信息 再展示界面，避免重复查询
loadUserInfo(() => {
  showPageFlag.value = true;
  // 登录成功后检查并展示更新日志（更新日志详情页不弹窗）
  nextTick(() => {
    if (!route.path.includes('/updateLog')) {
      updateLogModalRef.value?.checkAndShowUpdateLog();
    }
  });
});
//如果还没加载完 则自动关闭
// setTimeout(() => {
//   showPageFlag.value = true;
// }, 3000);
const isSinglePage = getUrlParams('isSinglePage', true); // 判断是否为单页面,ngs需要单独跳转页面
const {
  templateId,
  appId,
  showType,
  runningShow,
  judgmentIsAppOrTemp
} = useAppAndTemplate();

//判断是否为app或者模版访问
judgmentIsAppOrTemp(href);
//界面水印信息 设置
const {model} = useWatermarkHooks();

const fileConfigs = ref('');
const roleAppConfigs=ref({});
//加载状态标志
const {loadingFlag,devFlag,pageWaterFlagVal} = useAppLoad(locale, showType,fileConfigs,showPageFlag,roleAppConfigs);
provide('fileConfigs', fileConfigs);
provide('roleAppConfigs', roleAppConfigs);

const token = StorageUtils.getSessionItem('sessionId');
const {}=useLoginSwitchHook({token});
window.runningFlag=true;


</script>
<style lang="less">
@import './main-page/less/mainPage.less';
.xmBorderBottom {
  border-bottom: 1px solid #dfdfdf;
}

.full-modal {
  .ant-modal {
    max-width: 100%;
    top: 0;
    padding-bottom: 0;
    margin: 0;
  }
  .ant-modal-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh);
  }

  .ant-modal-body {
    flex: 1;
  }
}
.h99b {
  height: 96%;
}
.w99b {
  width: 96%;
}
.loadingApp {
  z-index: 99999;
  position: absolute;
  top: 0;
  left: 0;

  .ant-spin-dot {
    width: 2em;
    height: 2em;
  }

  .ant-spin-dot-item {
    width: 16px;
    height: 16px;
  }
}

#app .ant-spin-dot {
  width: 2em;
  height: 2em;
}

#app .ant-spin-dot-item {
  width: 16px;
  height: 16px;
}
.ant-col {
  .xmHidden-col-ctl{
    display: none !important;
  }
  &.xmHidden-col-ctl{
    display: none !important;
  }
}
.totalLoading.ant-spin {
  position: absolute;
  z-index: 99999;
  top: 0;
  width: 100%;
  height: 100%;
  left: 0;
  padding-top: 16%;
}

#app .ant-layout.ant-layout.ant-layout-has-sider {
  background-color: var(--page-bg-color);
}
</style>
